import { makeStyles, Grid, Typography, LinearProgress } from "@material-ui/core";
import { useSelector } from "react-redux";

import { COLORS } from "../../../../theme/colors";
import { getPercent, nFormatter } from "../../../../services/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 14,
  },
  colorPrimary: {
    backgroundColor: "transparent",
  },
  bar: {
    backgroundColor: COLORS.darks[0][25],
  },
  activeBar: {
    backgroundColor: COLORS.purple,
  },
  wordBreak: {
    wordBreak: "break-word",
  },
  activeTypography: {
    color: COLORS.purple,
    fontWeight: 700,
  },
  activeTypographyConsumption: {
    color: COLORS.purple,
  },
  grid: {
    marginBottom: `${theme.spacing(1.625)}px`,
  },
}));

export const Rank = ({ users }) => {
  const classes = useStyles();
  const highestValue = Math.max.apply(
    Math,
    users.map((user) => user.consumption)
  );
  const { cluster } = useSelector((state) => state.selectCSC);

  return users.map((usr, i) => (
    <Grid key={i} container alignItems="center" spacing={2} className={classes.grid}>
      <Grid item xs={3} align="left" className={classes.wordBreak}>
        <Typography
          variant="body2"
          className={`${usr.id === cluster.id ? classes.activeTypography : ""}`}
        >
          {usr.name}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <LinearProgress
          value={+getPercent(usr.consumption, highestValue)}
          variant="determinate"
          classes={{
            root: classes.root,
            bar: usr.id === cluster.id ? classes.Activebar : classes.bar,
            colorPrimary: classes.colorPrimary,
          }}
          size={14}
        />
      </Grid>
      <Grid item xs={3} align="right" className={classes.wordBreak}>
        <Typography
          variant="body2"
          className={`${usr.id === cluster.id ? classes.activeTypographyConsumption : ""}`}
        >
          {nFormatter(usr.consumption)}
        </Typography>
      </Grid>
    </Grid>
  ));
};
